// extracted by mini-css-extract-plugin
export default {"container":"TakeQuiz_container__8wJfs","innerContainer":"TakeQuiz_innerContainer__nLp9f","girlWithPhoneImg":"TakeQuiz_girlWithPhoneImg__0TAOr","p1":"TakeQuiz_p1__irybU"};